function injectStyle (ssrContext) {
  require("!!../../../../raypro-client/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../raypro-client/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-233a2d28\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"indentedSyntax\":true,\"sourceMap\":true}!../../../../raypro-client/node_modules/vue-loader/lib/selector?type=styles&index=0!./DeleteConfirm.vue")
}
var normalizeComponent = require("!../../../../raypro-client/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../raypro-client/node_modules/vue-loader/lib/selector?type=script&index=0!./DeleteConfirm.vue"
import __vue_script__ from "!!babel-loader!../../../../raypro-client/node_modules/vue-loader/lib/selector?type=script&index=0!./DeleteConfirm.vue"
/* template */
import __vue_template__ from "!!../../../../raypro-client/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-233a2d28\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../raypro-client/node_modules/vue-loader/lib/selector?type=template&index=0!./DeleteConfirm.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-233a2d28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/components/ui/DeleteConfirm.vue
// module id = null
// module chunks = 